export const state = () => ({
  feedbackOptions: [],
  bookingId: null,
  feedbackDialog: false,
  feedbackIsSubmitted: false
})
